import { type FC } from "react";

const STEPS = [
  "Open your phone's camera app",
  "Point the camera at the QR code",
  "Take a picture of the certificate",
];

interface QrUploadInstructionsProps {
  uploadCount?: number;
}

export const QrUploadInstructions: FC<QrUploadInstructionsProps> = ({ uploadCount = 0 }) => {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-3">
      <p className="text-base font-semibold tracking-[-0.32px] text-primary">
        Scan this with your phone
      </p>

      <div className="flex flex-col gap-3">
        {STEPS.map((text, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background text-sm font-medium text-primary">
              {i + 1}
            </span>
            <p className="text-sm text-secondary">{text}</p>
          </div>
        ))}
      </div>

      <p className="text-sm text-secondary">The photo will appear on this page automatically</p>

      {uploadCount > 0 && (
        <p className="text-sm font-medium text-brand">
          {uploadCount} {uploadCount === 1 ? "document" : "documents"} received
        </p>
      )}
    </div>
  );
};
